import React from 'react';
import I18n from 'i18n-js';

import { RCButton } from '@reverbdotcom/cadence/components';
import { Listing } from '@reverbdotcom/commons/src/gql/graphql';
import SellerListingsCollectionContext from '../listings_management/SellerListingsCollectionContext';
import RenewListingModal from './RenewListingModal';

interface IExternalProps {
  listing: Listing;
}

export default function RenewListingButton({
  listing,
}: IExternalProps) {
  const {
    useLazySellerListingsQuery,
  } = React.useContext(SellerListingsCollectionContext);

  const { refetchSellerListings } = useLazySellerListingsQuery();

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <div>
      <RCButton
        variant="muted"
        size="mini"
        title={I18n.t('discovery.listingsManagement.renewListing.button')}
        onClick={() => setIsModalOpen(true)}
      >
        {I18n.t('discovery.listingsManagement.renewListing.button')}
      </RCButton>

      <RenewListingModal
        isOpen={isModalOpen}
        listing={listing}
        requestClose={() => setIsModalOpen(false)}
        onSuccessCallback={() => {
          setIsModalOpen(false);
          refetchSellerListings([listing.id]);
        }}
      />
    </div>
  );
}
